<div class="nav" [ngClass]="{'horizontal':layout === 'horizontal', 'vertical':layout === 'vertical'}">
 
    <!-- Vertical Navigation Layout -->
    <ng-container *ngIf="layout === 'vertical'">
        <form [formGroup]="myForm" *ngIf="!firstAccess">
            <div class="div-busca-menu">
                <mat-icon class="icon-buscar-menu">search</mat-icon> 
                <input formControlName="campoPesquisa" (input)="filtrarItensMenu()"  class="input-busca-menu" type="search" placeholder="Pesquisar" >
            </div>
        </form>

        <ng-container *ngFor="let item of filteredItens"> 
            <fuse-nav-vertical-group *ngIf="item.type=='group'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-vertical-group>
            <fuse-nav-vertical-collapsable *ngIf="item.type=='collapsable'" [item]="item" [attr.data-test-id]="item.id" ></fuse-nav-vertical-collapsable>
            <fuse-nav-vertical-item *ngIf="item.type=='item'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-vertical-item>
        </ng-container>
        
<!--         <ng-container *ngFor="let item of navigation"> 
            <ng-container *ngIf="item.visible">
              <fuse-nav-vertical-group *ngIf="item.type=='group'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-vertical-group>
              <fuse-nav-vertical-collapsable *ngIf="item.type=='collapsable'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-vertical-collapsable>
              <fuse-nav-vertical-item *ngIf="item.type=='item'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-vertical-item>
            </ng-container>
        </ng-container> -->

    </ng-container>
    <!-- / Vertical Navigation Layout -->

    <!-- Horizontal Navigation Layout -->
    <ng-container *ngIf="layout === 'horizontal'">

        <ng-container *ngFor="let item of navigation">

            <fuse-nav-horizontal-collapsable *ngIf="item.type=='group'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-horizontal-collapsable>
            <fuse-nav-horizontal-collapsable *ngIf="item.type=='collapsable'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-horizontal-collapsable>
            <fuse-nav-horizontal-item *ngIf="item.type=='item'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-horizontal-item>

        </ng-container>

    </ng-container>
    <!-- / Horizontal Navigation Layout -->

</div>
